import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useLazyQuery } from '@apollo/client';
import ErrorWrapper from './ErrorWrapper';
import LoadingIndicator from './LoadingIndicator';
import styles from '../styles/ContactForm.module.css';
import btnStyles from '../styles/buttons.module.css';
import { AuditCompanyQuery } from '../queries';
import { UpdateStepWithData } from '../types';

type Props = {
  onNext: UpdateStepWithData;
};

type Errors = {
  [key: string]: string;
};

const ContactForm = ({ onNext }: Props) => {
  const [getAudit] = useLazyQuery(AuditCompanyQuery, {
    onCompleted: (data) => {
      onNext({ jobId: data?.auditCompany.jobId }, 1);
    },
  });

  const validate = (values): Errors => {
    const errors: Errors = {};

    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.address) {
      errors.address = 'Required';
    }

    return errors;
  };

  return (
    <div className={styles.contactForm}>
      <h1>Get a free audit of your business reviews</h1>
      <Formik
        initialValues={{
          name: '',
          address: '',
          phone: '',
        }}
        validate={validate}
        onSubmit={(values) => {
          getAudit({
            variables: {
              companyName: values.name,
              phoneNumber: values.phone,
              postCode: values.address,
            },
          });
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div>
              <label htmlFor="name">Company name</label>
              <Field id="name" name="name" placeholder="Company name" />
              <ErrorMessage name="name">
                {(msg) => <ErrorWrapper msg={msg} name="name" />}
              </ErrorMessage>

              <label htmlFor="address">Address</label>
              <Field id="address" name="address" placeholder="Address or post code" />
              <ErrorMessage name="address">
                {(msg) => <ErrorWrapper msg={msg} name="address" />}
              </ErrorMessage>

              <label htmlFor="phone">Phone</label>
              <Field id="phone" name="phone" placeholder="Phone number" />

              <button className={btnStyles.btnBlue} type="submit" disabled={isSubmitting}>
                {isSubmitting ? <LoadingIndicator fill="none" /> : 'Get free report'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ContactForm;
